/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Timeago from "react-timeago";
import { dateFormatter, getTextColor, timestampFirstFormatter } from "../../../utils/utils";
import { ReadTime } from "../ReadTime";

import "./publish-details.m.css";
import { useStateValue } from "../../SharedContext";

export const PublishDetails = ({ story, opts = {} }) => {
  const [direction, setDirection] = useState("ltr");
  useEffect(() => {
    const htmlElement = document.getElementsByTagName("HTML");
    if (htmlElement && htmlElement.length > 0 && htmlElement[0].dir.toLocaleLowerCase() === "rtl") {
      setDirection("rtl");
    }
  }, []);
  const config = useStateValue() || {};
  const { "first-published-at": firstPublishAt, "last-published-at": lastPublish, "updated-at": updatedAt } = story;
  const { enableUpdatedTime, enablePublishedTime, showReadTime } = opts;
  const time = lastPublish || firstPublishAt;
  const textColor = getTextColor(config.theme);

  return (
    <div data-test-id="timeStamp" className="arrow-component arr-publish-details" styleName={`timeStamp ${textColor}`}>
      <div data-test-id="publishDetails" styleName={`publish-details ${textColor}`}>
        {enablePublishedTime && (
          <>
            Published on :&nbsp;
            <Timeago
              styleName="date"
              date={time}
              formatter={direction === "rtl" ? timestampFirstFormatter : dateFormatter}
            />
            {showReadTime && <ReadTime story={story} opts={opts} />}
          </>
        )}
      </div>
      {enableUpdatedTime && (
        <div data-test-id="updateDetails" styleName={`update-details ${textColor}`}>
          Updated on :&nbsp;
          <Timeago
            styleName="date"
            date={updatedAt}
            formatter={direction === "rtl" ? timestampFirstFormatter : dateFormatter}
          />
          {showReadTime && <ReadTime story={story} opts={opts} />}
        </div>
      )}
    </div>
  );
};

PublishDetails.propTypes = {
  /** The Story Object from the API response */
  story: PropTypes.shape({
    "first-published-at": PropTypes.number,
    "last-published-at": PropTypes.number,
    "read-time": PropTypes.number,
    "updated-at": PropTypes.number
  }),
  opts: PropTypes.shape({
    showReadTime: PropTypes.bool,
    enableUpdatedTime: PropTypes.bool,
    enablePublishedTime: PropTypes.bool
  })
};
